export const SET_FEEDBACK_EMAIL = 'SET_FEEDBACK_EMAIL';
export const SET_FEEDBACK_MESSAGE = 'SET_FEEDBACK_MESSAGE';
export const SET_FEEDBACK_TYPE = 'SET_FEEDBACK_TYPE';
export const SET_FEEDBACK_LEVEL = 'SET_FEEDBACK_LEVEL';
export const SET_FEEDBACK = 'SET_FEEDBACK';
export const RESET_FEEDBACK = 'RESET_FEEDBACK';
